"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _chevronDownSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-down-small"));
var _label = _interopRequireDefault(require("@ingka/label"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formField = require("@ingka/form-field");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Select = _ref => {
  let {
    describedById,
    onChange,
    className,
    prefix,
    hintText,
    id,
    label,
    ssrIcon,
    req,
    value,
    children,
    disabled,
    ...other
  } = _ref;
  const {
    shouldValidate,
    valid
  } = (0, _react.useContext)(_formField.FormFieldContext);
  const [withHint, setWithHint] = (0, _react.useState)(false);
  const selectRef = (0, _react.useRef)();
  const hintOptionRef = (0, _react.useRef)();
  const handleOnChange = e => {
    if (onChange) {
      onChange(e, Boolean(hintOptionRef.current && hintOptionRef.current.selected));
    }
    if (hintOptionRef.current) {
      setWithHint(hintOptionRef.current.selected);
    }
  };
  (0, _react.useEffect)(() => {
    if (hintOptionRef.current) {
      setWithHint(hintOptionRef.current.selected);
    }
  }, [value]);
  const baseClass = `${prefix}select`;
  const classes = (0, _classnames.default)(`${baseClass}`, shouldValidate && !valid && `${baseClass}--error`, shouldValidate && valid && `${baseClass}--success`, disabled && `${baseClass}--disabled`, ssrIcon && `${baseClass}--leading-icon`, `${prefix}label-wrapper ${prefix}label-wrapper--text-input`, withHint && `${baseClass}--hint`, className);
  return _react.default.createElement("div", {
    className: classes
  }, label && _react.default.createElement(_label.default, {
    title: label,
    prefix: prefix,
    htmlFor: id,
    label: label,
    reqText: req
  }), _react.default.createElement("div", {
    className: `${baseClass}__wrapper`
  }, _react.default.createElement("select", _extends({
    value: value,
    ref: selectRef,
    id: id,
    disabled: disabled,
    onChange: handleOnChange,
    "aria-describedby": describedById
  }, other), hintText && _react.default.createElement("option", {
    value: hintText,
    ref: hintOptionRef
  }, hintText), children), ssrIcon && _react.default.createElement(_ssrIcon.default, {
    className: `${baseClass}__icon`,
    paths: ssrIcon,
    prefix: prefix
  }), _react.default.createElement(_ssrIcon.default, {
    className: `${baseClass}__chevron-down`,
    prefix: prefix,
    paths: _chevronDownSmall.default
  }), _react.default.createElement("span", {
    className: `${baseClass}__border`
  })));
};
Select.defaultProps = {
  disabled: false,
  prefix: '',
  hintText: 'Choose an option'
};
var _default = Select;
exports.default = _default;